import { render } from "./Footer.vue?vue&type=template&id=7452299e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7452299e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7452299e"

export default script